import { actRequest, type RESP } from "./request"

export type CheckUserResult = {
    results: {
        userId: string
        sdkId: string
        nickname: string
        level: number
        avatar: {
            url: string
            type: string
            id: string
        }
        lastOnlineTs: number
        cache: boolean | null
        token: string | null
    }
}

/** SDK 认证（游戏外首次登录） */
export const requestLogin = async (token: string, sdkId: string, channel = "official") => {
    return actRequest.post<null, RESP<CheckUserResult>>(
        `/api/activities/${__ACTIVITY_CID}/account/checkuser`,
        { sdkId, token, channel },
    )
}

/** 页面初始化时验证 Cookie，返回当前用户信息；403 表示未登录或已过期 */
export const requestGetRole = async () => {
    return actRequest.get<null, RESP<CheckUserResult>>(
        `/api/activities/${__ACTIVITY_CID}/account/checkuser`,
    )
}

/** WebView 认证 或 JWT 续期（传入 auth 字段） */
export const requestLoginByAuth = async (auth: string) => {
    return actRequest.post<null, RESP<CheckUserResult>>(
        `/api/activities/${__ACTIVITY_CID}/account/checkuser`,
        { auth },
    )
}

export const requestLogout = async () => {
    return actRequest.post<null, RESP<null>>(
        `/api/activities/${__ACTIVITY_CID}/account/logout`,
    )
}
